<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>区域</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>操作日志</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <!-- <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all，
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="equipType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
          </el-tree>
        </el-card>
      </el-aside> -->
      <!-- 右边 -->
      <el-main class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 100%;">
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
          <div style=" margin: 10px 20px;display:flex;align-items: center;height:60px">
            <div class="grid-search">
              <!-- <span>类型:</span>
             <el-select v-model="search.equipType" clearable  @change="doFilter" placeholder="请选择">
              <el-option
                v-for="item in dataTree"
                :key="item.equipType"
                :label="item.name"
                :value="item.equipType"
                 >
              </el-option>
            </el-select> -->
            </div>
            <div class="grid-search">
              <!-- <el-input v-model="search.personName" placeholder="请输入人员名称"  clearable @input="doFilter">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input> -->
            </div>
            <el-button type="primary" @click="add">添加</el-button>
          </div>
          <div class="build-table">
            <el-table :data="listData" height="100%" style="width: 100%;" stripe
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="区域名称" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a>{{ scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span>{{ scope.row.address }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="primary" @click="lineDev(scope.$index, scope.row)">关联设备</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页展示 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <!-- 添加弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      class="add-form" @closed="mapClose" @open="mapOpen" width="90%" top="10vh" custom-class="map-dialog">
      <el-form :model="addForm" ref="addForm" label-width="150px" :label-position="labelPosition">
        <el-form-item label="区域名称：">
          <el-input v-model="addForm.name" autocomplete="off" placeholder="请输入区域名称" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="gps位置:">
          <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:600px;width:100%;"
            @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
          <!-- <div class="mapBtn">
            <button class="mapClearCur" style="backgroundColor: #FFB800" @click="mapClearCur">清除当前区域</button>
          </div> -->
          <!-- <div class="mapSearch">
            <input type="text" v-model="searchInput" id="searchCon" style="width:300px;height:40px;margin:0;" />
            <button class="layui-btn layui-btn-normal" @click="btnSearchFun"
              style="height:38px;top: 6px;position: relative;margin-left:10px;background:#43ADFC">查询</button>
          </div> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import myHttp from '../../untils/port.js'
  import util from '../../untils/util.js'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        labelPosition: 'right',
        dataTree: [{ name: '喷淋', equipType: '1' }, { name: '雾炮', equipType: '2' }, { name: '照明', equipType: '3' }],
        listData: [],
        search: {
          //查询
        },
        classId: '', //班组id
        // currentPage: 1,
        // pageSize: 10,
        // totalItems: 0,
        dataText: '数据加载中...',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        currentNodekey: '', //默认选中的节点树
        expandedkeys: [], //默认展开的节点树
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        addFormVisible: false,
        dialogTitle: '',
        addForm: {
          id: '',
          name: '', //区域名称
          gpsPoint: '',
          address:''
        },
        center: { lng: 117.283334, lat: 31.866339 },
        zoom: 13,
        map: {},
        geoc: {},
        BMap:undefined,
        local: '',//本地地图查询
        currentPonit: [],//当前区域的经纬度
        searchInput: '',
      }
    },
    created() {
      if (util.session.get('roleId') == '4') {
        this.search.projectId = util.session.get('groupId')
        // this.search.projectId = '1226783469518934018'
      } else {
        this.search.projectId = util.session.get('proId')
      }
    },
    mounted() {

      // this.search.projectId  =util.
      // if (this.dataTree.length > 0) {
      //         this.currentNodekey = this.dataTree[0].equipType
      //         this.expandedkeys.push(this.dataTree[0].equipType)
      //         this.$nextTick(() => {
      //           // treeBox 元素的ref   value 绑定的node-key
      //           this.$refs.tree.setCurrentKey(this.currentNodekey)
      //         })
      //       }
      this.getData()
      // this. getMate()
    },
    methods: {
      // 搜索数据
      doFilter() {
        // this.search.startDate = this.date ? this.date[0] : ''
        // this.search.endDate = this.date ? this.date[1] : ''
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this
        this.search.pageSize = this.pageSize,
        this.search.pageNum = this.currentPage,
          myHttp
            .selectAllPageEquipBlocks(this.search)
            .then(
              function (resp) {
                if (resp.data.code == '200') {
                  var list = resp.data.data.pageInfo.list || []
                  for (var i = 0; i < list.length; i++) {
                    // console.log(list[i].gpsPoint)
                    // var arry = list[i].gpsPoint.split(',')
                    // var point = {
                    //   lat:arry[0],
                    //   lng:arry[1],
                    // }
                    list[i].index =
                      that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                      // list[i].address = that.getAddress(list[i].gpsPoint)
                  }
                  that.listData = list
                  // console.log(list)
                  that.totalItems = resp.data.data.pageInfo.total || 0
                  if (list.length == 0) {
                    that.dataText = '暂无数据'
                  }
                } else {
                  that.$message.error(resp.data.msg)
                  that.dataText = '暂无数据'
                }
              },
              function () {
                that.dataText = '服务器繁忙中，请稍后请求'
              }
            )
      },


      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      add() {
        this.addFormVisible = true
        this.dialogTitle = '添加区域',
        this.addForm.id =''
        this.addForm.name =''
        this.addForm.gpsPoint = ''
        this.addForm.address = ''
      },
      // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        that.addForm.projectId = this.search.projectId
        console.log(that.addForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (that.addForm.id == '') {
              that.addForm.createBy = util.session.get('user').id
              //添加 222
              myHttp.addEquipaddEquipBlocks(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.currentPage = 1
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () { }
              )
            } else {
              //修改 1111
              that.addForm.updateBy = util.session.get('user').id
              myHttp.updateEquipBlocks(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () { }
              )
            }
            // that.$message.error('功能暂未开放')
          }
        })
      },
      //获取区域
      setAreaFun(id) {
        if ('' == id || undefined == id) return
        var that = this
        myHttp
          .getAreaById({
            id: id
          })
          .then(
            function (resp) {
              if (resp.data.code == '200') {
                var province = resp.data.data.area.provinceId
                var city = resp.data.data.area.cityId
                var area = resp.data.data.area.countyId
                if (resp.data.data.area.level == '3' && undefined == area) {
                  area = resp.data.data.area.id
                }
                var arry = []
                arry.push(province)
                arry.push(city)
                arry.push(area)
                that.selectedOptions = arry
              }
            },
            function (error) { }
          )
      },
      //百度地图弹出框
      //解决鼠标滚动中心不再鼠标点上
      mapOpen: function () {
        this.top = this.getScrollTop()
        if (this.top) {
          this.setScrollTop(0)
        }
      },
      mapClose: function () {
        this.setScrollTop(this.top);
        this.top = 0;
      },
      getScrollTop: function () {
        let scrollTop = 0;
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollTop = document.body.scrollTop;
        }
        return scrollTop;
      },
      setScrollTop: function (top) {
        if (!isNaN(top)) {
          if (document.documentElement && document.documentElement.scrollTop !== undefined) {
            document.documentElement.scrollTop = top;
          } else if (document.body) {
            document.body.scrollTop = top;
          }
        }
      },
      //地图展示
      handler({ BMap, map }) {
        this.map = map
        this.geoc = new BMap.Geocoder()
        console.log(map)
        //根据内容展示中心点
        this.local = new BMap.LocalSearch(map, {
          renderOptions: { map: map }
        });
        if (this.addForm.id && '' != this.addForm.id) {
          // this.getInfo()
        };
        // }
      },
      //地图点击方法
      getClickInfo(e) {
        this.map.clearOverlays()
        var point = new BMap.Point(e.point.lng, e.point.lat)
        var marker = new BMap.Marker(point)
        this.map.addOverlay(marker)
        this.addForm.gpsPoint = e.point.lng + ',' + e.point.lat
        // console.log(e.point)
        var that = this
         this.geoc.getLocation(e.point, function(rs) {
          var addComp = rs.addressComponents
          var address =
            addComp.province +
            addComp.city +
            addComp.district +
            addComp.street +
            addComp.streetNumber
          // that.form.address = address
          if(!that.addForm.address && that.addForm.address==''){
            that.addForm.address = address
          }
        console.log(address)
        })
      },

      // 获取位置
      // getAddress(point){
      //   var that = this
      //   // var map = new BMap.Map("allmap");
      //   var point = new BMap.Point(point);
      //   var gc = new BMap.Geocoder();

      //   gc.getLocation(point, function(rs){
      //     var addComp = rs.addressComponents;
      //     var address =
      //         addComp.province +
      //         addComp.city +
      //         addComp.district +
      //         addComp.street +
      //         addComp.streetNumber
      //       // that.form.address = address
      //     if (!that.addForm.address && that.addForm.address == '') {
      //         that.addForm.address = address
      //       }
      //       console.log(address)
      //   });
      // },
      //设置地图坐标和中点
      setCenterMap(obj) {
        var point = new BMap.Point(this.center.lng, this.center.lat)
        this.map.centerAndZoom(point, 12)
        var marker = new BMap.Marker(point)
        this.map.addOverlay(marker)
      },
      //清除当前区域
      mapClearCur() {
        // this.currentPonit = [];
        // this.map.clearOverlays();
      },
      //点击查询
      btnSearchFun() {
        this.local.search(this.searchInput);
      },
      //修改
      handleEdit(index, row) {
        // console.log(row)
        var that = this
        this.addFormVisible = true
        this.dialogTitle = '修改'
        // selectOneequipCrossingLine
        myHttp.selectOneequipBlocks({
          id: row.id
        }).then(
          function (resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              var data = resp.data.data.EquipBlocks
              that.addForm.name = data.name
              that.addForm.id = data.id
              that.map.clearOverlays()
              if(data.gpsPoint && ''!=data.gpsPoint){
                        that.addForm.gpsPoint = data.gpsPoint
                        var point = new BMap.Point(data.gpsPoint.split(',')[0],data.gpsPoint.split(',')[1]);
                        // 创建标注  
                        // console.log(data.gpsPoint)
                        var marker = new BMap.Marker(point);
                        // 将标注添加到地图中
                        that.map.addOverlay(marker);
                        that.center = {
                            lng:that.addForm.gpsPoint.split(',')[0],
                            lat:that.addForm.gpsPoint.split(',')[1]
                        }
                      // console.log( that.center)
                    }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () { }
        )
      },
      handleDelete(index, row) {
          var that = this
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          })
          .then(() => {
          myHttp
              .deleteEquipBlocks({
              id: row.id
              })
              .then(function(resp) {
              if (resp.data.code == '200') {
                  that.$message({
                  type: 'success',
                  message: '删除成功!'
                  })
                  that.getData()
              } else {
                  that.$message.error(resp.data.msg)
              }
              })
          })
          .catch(err => {})
      },

      //关联设备
      lineDev(index,row){
        this.$router.push({path:'/areaDev/'+row.id})
      },


    },

  }
</script>
<style>
  /**
*图片放大右上角关闭按钮
*/
  .el-image-viewer__close i {
    font-size: 4vh;
    color: #fff;
  }

  /* @import '../../assets/css/common.css'; */
</style>
<style scoped>
  /* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }

  /* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .build-table {
    height: calc(100% - 160px);
  }

  .active {
    background: #409eff;
    color: #fff;
  }

  .contract-con {
    width: 100%;
    background: #fff;
    height: 125px;
    font-size: 14px;
  }

  .contract-con p {
    width: 100%;
    padding: 2px 20px;
    text-align: left;
  }

  .content>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    color: #4d95fd;
    font-weight: bold;
    padding: 10px 0px;
  }

  .content>>>.el-input-group--append .el-input__inner {
    width: 200px;
  }

  .content>>>.el-tree {
    padding: 30px;
  }

  .grid-search {
    margin-right: 10px;
  }

  .item-con .item {
    width: 33%;
    display: flex;
    align-items: center;
  }

  .mapBtn {
    z-index: 100;
    position: absolute;
    top: 1.5vh;
    left: 5px;
    display: inline-block;
  }

  .mapBtn>button,
  .mapSearch>button {
    border: 0;
    outline: 0;
    padding: 10px;
    color: #fff
  }

  .mapSearch {
    z-index: 100;
    position: absolute;
    top: 1.5vh;
    right: 5px;
    display: inline-block;
  }

  .mapClear,
  .mapSub {
    margin-right: 10px;
  }
</style>